import { withInstall } from '@ll-plus/utils'

import FormComponent from './src/components/form-component.vue'
import Form from './src/form.vue'

export const LlFormComponent = withInstall(FormComponent)
export const LlForm = withInstall(Form)
export default LlForm
export * from './src/config'

declare module 'vue' {
  export interface GlobalComponents {
    LlFormComponent: typeof FormComponent
    LlForm: typeof Form
  }
}
